// App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Dashboard from './Dashboard';
import Plots from './Plots';
import Realtime from './Realtime';
import Forecast from './Forecast';
import Webcams from './Webcams';
import Observability from './Observabilty';
import Meteosat from './Meteosat';

import Settings from './components/Settings';


import Header from './components/Header';
import Footer from './components/Footer';

import ErrorBoundary from './components/ErrorBoundary';


function App() {
  return (
      <Router basename={process.env.PUBLIC_URL || ''}>
        <Header />
        <div className="container py-3">
          <Routes>
            <Route path='/' element={<ErrorBoundary><Dashboard /></ErrorBoundary>} />
            <Route path='/plots' element={<ErrorBoundary><Plots /></ErrorBoundary>} />
            <Route path='/realtime' element={<ErrorBoundary><Realtime /></ErrorBoundary>} />
            <Route path='/forecast' element={<ErrorBoundary><Forecast /></ErrorBoundary>} />
            <Route path='/observability' element={<ErrorBoundary><Observability /></ErrorBoundary>} />
            <Route path='/webcams' element={<ErrorBoundary><Webcams /></ErrorBoundary>} />
            <Route path='/meteosat' element={<ErrorBoundary><Meteosat /></ErrorBoundary>} />
             <Route path="/settings" element={<Settings />} /> 
          </Routes>
        </div>
        <Footer />
      </Router>
  );
}

export default App;